import { __read, __spreadArray, __values } from "tslib";
import { AppBarFlyoutLinkID, HubTileID } from '@office-start/appbar-types';
import { useCapabilities } from '@office-start/capabilities-service';
import { copilotM365AppId, onedriveMOSAppId, } from '@office-start/data-resolver-app-pinning';
import { useLocStrings } from '@office-start/loc-service';
import * as React from 'react';
import { useAppDefinitionTileData } from './useAppDefinitionTileData';
import { useHubTileData } from './useHubTileData';
import { useThirdPartyTileData } from './useThirdPartyTileData';
import { useWorkspacesTileData } from './useWorkspacesTileData';
// A mapping of tile IDs to locked indices in Harmony
var lockedIndexForApps = new Map([
    [HubTileID.home, 0],
    [HubTileID.create, 1],
    [HubTileID.mycontent, 2],
    [HubTileID.orion, 3],
    [HubTileID.feed, 4],
    [HubTileID.appgallery, 5],
    [copilotM365AppId, 6],
    [onedriveMOSAppId, 7],
]);
/**
 * Custom React Hook responsible for resolving enterprise app bar data
 */
export function useEnterpriseAppBarTileData() {
    var locStrings = useLocStrings().data;
    var capabilities = useCapabilities().data;
    var resources = locStrings === null || locStrings === void 0 ? void 0 : locStrings.appBarResources;
    var hubTileData = useHubTileData();
    var appDefinitionTileData = useAppDefinitionTileData();
    var workspacesTileData = useWorkspacesTileData();
    var thirdPartyTileData = useThirdPartyTileData();
    var _a = __read(React.useState({
        m365Apps: {
            edges: [],
            appAcquisitionLinks: [],
        },
    }), 2), tileData = _a[0], setTileData = _a[1];
    React.useEffect(function () {
        var e_1, _a;
        var tileData = {
            m365Apps: {
                edges: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(hubTileData), false), __read(appDefinitionTileData), false), __read(workspacesTileData), false), __read(thirdPartyTileData), false),
                appAcquisitionLinks: [],
            },
        };
        try {
            // Apply lock indices to locked tiles in Harmony
            for (var _b = __values(tileData.m365Apps.edges), _c = _b.next(); !_c.done; _c = _b.next()) {
                var edge = _c.value;
                edge.node.lockedIndex = lockedIndexForApps.get(edge.node.id);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // Add store link to flyout if not enabled via appBarOverflowOnlyEnabled
        if (!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarOverflowOnlyEnabled)) {
            if (capabilities === null || capabilities === void 0 ? void 0 : capabilities.storeAppEnabled) {
                tileData.m365Apps.appAcquisitionLinks.push({
                    id: AppBarFlyoutLinkID.store,
                    icon: {
                        name: 'AddSquareIcon',
                    },
                    text: resources === null || resources === void 0 ? void 0 : resources.addAppsLinkText,
                    accessibleName: resources === null || resources === void 0 ? void 0 : resources.addAppsLinkText,
                });
            }
        }
        setTileData(tileData);
    }, [
        hubTileData,
        appDefinitionTileData,
        workspacesTileData,
        thirdPartyTileData,
        capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarOverflowOnlyEnabled,
        capabilities === null || capabilities === void 0 ? void 0 : capabilities.storeAppEnabled,
        resources,
    ]);
    return tileData;
}
//# sourceMappingURL=useEnterpriseAppBarTileData.js.map